import { ReactNode } from 'react';
import styled from 'styled-components';
import { colors } from '@karnott/colors';
import { pixelSize, pixelSpacing } from '@karnott/theme';
import { size, spacing } from './theme';

export const Steps = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  width: 100%;
  font-size: ${pixelSize('regular')};
`;

const StepWrapper = styled.div<{ inline?: boolean }>`
  margin-bottom: ${(props) => (props.inline ? 0 : spacing)}px;
  span {
    svg {
      font-size: ${size('xxl')};
    }
  }
  svg {
    color: ${colors('orange', 'dark')};
  }
`;
const StepIndex = styled.span`
  font-weight: 700;
`;
const StepTitle = styled.div`
  font-weight: 700;
`;

export const ModalLink = styled.a`
  color: ${colors('orange', 'dark')};
  text-decoration: none;
`;

const StepSubContent = styled.div`
  display: flex;
  gap: ${pixelSpacing('xSmall')};
  align-items: center;
`;

type StepProps = {
  index?: number;
  inline?: boolean;
  content: ReactNode;
  title?: ReactNode;
  contentIcon?: ReactNode;
  subContent?: ReactNode;
  subContentIcon?: ReactNode;
};

export function Step({ index, inline, content, title, contentIcon, subContent, subContentIcon }: StepProps) {
  return (
    <StepWrapper inline={inline}>
      {index && (
        <StepIndex>
          {index}
          .&nbsp;
        </StepIndex>
      )}
      {title ? <StepTitle>{title}</StepTitle> : null}
      <span>
        {content} {contentIcon || null}
      </span>
      {subContentIcon && subContent ? (
        <StepSubContent>
          {subContentIcon} {subContent}
        </StepSubContent>
      ) : null}
    </StepWrapper>
  );
}
